module.exports = __webpack_public_path__ + "components/country-flag/static/bo-d4231977f5474ef9fccda8bbfd1cd88e.svg";